import React from 'react'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'

const StepDescription = ({ stepText, title, description }) => (
  <Grid item style={{ marginTop: '36px', marginBottom: '36px' }}>
    <Box display={{ xs: 'none', md: 'block' }}>
      <Typography variant="body1" style={{ fontWeight: '500' }}>
        {stepText}
      </Typography>
    </Box>
    <Typography variant="h4" style={{ marginTop: '8px', fontWeight: '700' }}>
      {title}
    </Typography>
    <Typography
      variant="body1"
      style={{ margin: '16px 0px', color: 'rgba(0, 0, 0, 0.54)' }}
    >
      {description}
    </Typography>
  </Grid>
)
export default StepDescription
